import { ErrorMessage } from '@occc-app/lib/ErrorMessage';

/* Action Types */

const GET_STARTED_UPDATE = 'hq/Offer/GetStarted/GET_STARTED_UPDATE';
const REQUEST_GET_STARTED_OK = 'hq/Offer/GetStarted/REQUEST_GET_STARTED_OK';
const RESET_INITIAL_GET_STARTED_STATE = 'hq/Offer/GetStarted/RESET_INITIAL_GET_STARTED_STATE';
const UPDATE_GET_STARTED = 'hq/Offer/GetStarted/UPDATE_GET_STARTED';
const UPDATE_GET_STARTED_ERR = 'hq/Offer/GetStarted/UPDATE_GET_STARTED_ERR';
const UPDATE_GET_STARTED_OK = 'hq/Offer/GetStarted/UPDATE_GET_STARTED_OK';

type Types = {
  GET_STARTED_UPDATE: typeof GET_STARTED_UPDATE;
  REQUEST_GET_STARTED_OK: typeof REQUEST_GET_STARTED_OK;
  RESET_INITIAL_GET_STARTED_STATE: typeof RESET_INITIAL_GET_STARTED_STATE;
  UPDATE_GET_STARTED: typeof UPDATE_GET_STARTED;
  UPDATE_GET_STARTED_ERR: typeof UPDATE_GET_STARTED_ERR;
  UPDATE_GET_STARTED_OK: typeof UPDATE_GET_STARTED_OK;
};

const types: Types = {
  GET_STARTED_UPDATE,
  REQUEST_GET_STARTED_OK,
  RESET_INITIAL_GET_STARTED_STATE,
  UPDATE_GET_STARTED,
  UPDATE_GET_STARTED_ERR,
  UPDATE_GET_STARTED_OK,
};

type GetStartedUpdate = (
  key: string,
  value: string,
) => {
  type: typeof GET_STARTED_UPDATE;
  key: string;
  value: string;
};

type RequestGetStartedOK = (getStartedGetStarted: GetStarted) => {
  type: typeof REQUEST_GET_STARTED_OK;
} & GetStarted;

type ResetInitialGetStartedState = (getStartedMetaData: GetStarted) => {
  type: typeof RESET_INITIAL_GET_STARTED_STATE;
  getStartedMetaData: GetStarted;
};

type UpdateGetStarted = () => {
  type: typeof UPDATE_GET_STARTED;
};

type UpdateGetStartedERR = (
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof UPDATE_GET_STARTED_ERR;
  errorMessages: ErrorMessage[];
  error: Error;
};

type UpdateGetStartedOK = () => {
  type: typeof UPDATE_GET_STARTED_OK;
};

export type Action =
  | ReturnType<GetStartedUpdate>
  | ReturnType<RequestGetStartedOK>
  | ReturnType<ResetInitialGetStartedState>
  | ReturnType<UpdateGetStarted>
  | ReturnType<UpdateGetStartedERR>
  | ReturnType<UpdateGetStartedOK>;

export type ActionCreators = {
  GetStartedUpdate: GetStartedUpdate;
  RequestGetStartedOK: RequestGetStartedOK;
  ResetInitialGetStartedState: ResetInitialGetStartedState;
  UpdateGetStarted: UpdateGetStarted;
  UpdateGetStartedERR: UpdateGetStartedERR;
  UpdateGetStartedOK: UpdateGetStartedOK;
};

/* State Types */

type OfferComponentMetaData = {
  error: Error | null;
  errorMessages: ErrorMessage[];
  dirty: boolean;
  submitting: boolean;
};
export type GetStarted = {
  category: string;
  externalId: string;
  name: string;
  offerDescription: string;
};
export type State = OfferComponentMetaData & GetStarted;

export default types;
